/*

 */

/**
 * Buy Foreign Exchange - currency conversion page
 *
 * https://www.msmaster.qa.paypal.com/elmo/experiment/101551
 *
 * Conditions:
 * - Control: existing currency conversion page
 * - Treatment: newly designed currency conversion page, zeplin: https://zpl.io/2Gyx46d
 */

import * as pxp from '../lib/pxp'

export function isBFXCurrencyConversionTrmt() {
  return pxp.isTreatment('Trmt_p2p_bfx_currency_conversion_1')
}
